import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';
import { filter } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

declare let gtag: any;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private document = inject(DOCUMENT);
  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);

  constructor(private router: Router) {
    if (this.isBrowser && localStorage.getItem('cookie_consent') === 'accepted') {
      this.initAnalytics();
    }
  }


  initAnalytics() {
    if (!this.isBrowser) return;

    // Éviter d'injecter le script plusieurs fois
    if (this.document.getElementById('google-analytics-script')) return;

    if (!environment.measurement_id) {
      console.warn('GA Measurement ID not set in environment.');
      return;
    }

    // 1. Script externe gtag.js
    const gtagScript = this.document.createElement('script');
    gtagScript.id = 'google-analytics-script';
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.measurement_id}`;
    this.document.head.appendChild(gtagScript);

    // 2. Script inline de configuration
    const inlineScript = this.document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      window.gtag = gtag; // Rend gtag accessible globalement sur window
      gtag('js', new Date());
      gtag('config', '${environment.measurement_id}', { 'anonymize_ip': true });
    `;
    this.document.head.appendChild(inlineScript);

    // 3. Lancer le tracking des pages vues
    this.trackPageViews();
  }

  private trackPageViews() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // On utilise window.gtag de manière sécurisée
      if (this.isBrowser && typeof (window as any).gtag === 'function') {
        (window as any).gtag('event', 'page_view', {
          page_path: event.urlAfterRedirects,
          page_location: window.location.href,
          page_title: this.document.title
        });
      }
    });
  }

  logEvent(eventName: string, params: Record<string, any> = {}) {
    if (this.isBrowser && typeof (window as any).gtag === 'function') {
      (window as any).gtag('event', eventName, params);
    }
  }

  setUserProperties(properties: Record<string, any>) {
    if (this.isBrowser && typeof (window as any).gtag === 'function') {
      (window as any).gtag('set', 'user_properties', properties);
    }
  }
}
